import React from 'react';
import Table from '../common/Table';
import { ComponentPlaceholderDTO } from '../../services/apiClient';

interface ComponentPlaceholderTableProps {
  data: ComponentPlaceholderDTO[];
  handleEdit: (placeholder: ComponentPlaceholderDTO) => void;
  handleDelete: (placeholder: ComponentPlaceholderDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const ComponentPlaceholderTable: React.FC<ComponentPlaceholderTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  const getTypeName = (type: any) => {
    // Handle both numeric and string enum values
    if (type === 0 || type === 'PropertyPath') return 'Property Path';
    if (type === 1 || type === 'SystemValue') return 'System Value';
    if (type === 2 || type === 'Generic') return 'Generic';
    return 'Unknown';
  };

  return (
    <Table
      columns={[
        {
          label: 'Tag',
          key: 'tag',
          render: (row: ComponentPlaceholderDTO) => (
            <span className="font-mono text-sm">{row.tag}</span>
          ),
        },
        {
          label: 'Path',
          key: 'path',
          render: (row: ComponentPlaceholderDTO) => (
            <span className="font-mono text-sm text-gray-600">
              {row.path || <span className="text-gray-400 italic">N/A</span>}
            </span>
          ),
        },
        {
          label: 'Description',
          key: 'description',
        },
        {
          label: 'Type',
          key: 'type',
          render: (row: ComponentPlaceholderDTO) => (
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              {getTypeName(row.type)}
            </span>
          ),
        },
        {
          label: 'Active',
          key: 'isActive',
          render: (row: ComponentPlaceholderDTO) => (
            <span
              className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                row.isActive
                  ? 'bg-green-100 text-green-800'
                  : 'bg-red-100 text-red-800'
              }`}
            >
              {row.isActive ? 'Yes' : 'No'}
            </span>
          ),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      allowPaging={false}
      isLoading={isLoading}
    />
  );
};

export default ComponentPlaceholderTable;
